import request from '@/utils/request'

let CourseSignUpApi = {

  /*课程列表*/
  list(data) {
    return request._post('/shop/plus.course.CourseSignUp/index', data);
},

}
export default CourseSignUpApi;



// WEBPACK FOOTER //
// ./src/api/course_sign_up.js